export default __webpack_public_path__ + "static/media/CV2021.9404d468.pdf";